module.exports = __webpack_public_path__ + "assets/pause_ride.de868704.svg";